import {ToggleGroup, ToggleGroupItem} from '@kroll-resolver-crisp/ui-components-react';
import {type SubmissionScope} from '@/store/uiStore';

const OPTIONS: Array<{value: SubmissionScope; label: string}> = [
  {value: 'mine', label: 'Mine'},
  {value: 'all', label: 'All analysts'}
];

// Segmented control over whose submissions the list shows. Base UI's ToggleGroup carries its value
// as an array even in single-select mode; an empty `next` is the analyst re-clicking the pressed
// option, which keeps the current scope rather than leaving neither pressed.
export function SubmissionScopeToggle({
  scope,
  onChange
}: {
  readonly scope: SubmissionScope;
  readonly onChange: (scope: SubmissionScope) => void;
}) {
  return (
    <ToggleGroup
      variant="outline"
      spacing={0}
      size="sm"
      aria-label="Submission scope"
      value={[scope]}
      onValueChange={(next) => {
        const [first] = next as SubmissionScope[];
        if (first) {
          onChange(first);
        }
      }}>
      {OPTIONS.map((option) => (
        <ToggleGroupItem key={option.value} value={option.value}>
          {option.label}
        </ToggleGroupItem>
      ))}
    </ToggleGroup>
  );
}
